import { ButtonLink } from '@goodfynd/ui';
import { Text } from '@goodfynd/ui';
import classnames from 'clsx';

import { Alert } from '../../Alert';

import type { OrderingAlertProps } from './types';

import classes from './OrderingStatusAlert.module.css';

export default function PayoutsPaused({
  buttonClick,
  busy,
  compact,
  css,
  ctaText = 'Schedule Your Call',
  icon,
  text = 'Stripe is set up! A quick call is needed to finalize your payout schedule and learn more about your business so we can best support you with Goodfynd.',
  type,
}: OrderingAlertProps) {
  return (
    <>
      <Alert
        icon={icon}
        type={type}
        css={{
          marginBottom: 24,
          maxWidth: 1121,
          width: '100%',
          '> aside': {
            '@xs': {
              alignItems: 'flex-start',
            },
          },
          '@xs': {
            marginBottom: 16,
          },
          ...css,
        }}
      >
        <div
          className={classnames(classes.content, {
            [classes.compact]: compact,
          })}
        >
          <Text>{text}</Text>

          {!busy && (
            <ButtonLink
              display="compact"
              href=""
              onClick={buttonClick}
              size="small"
            >
              {ctaText}
            </ButtonLink>
          )}
        </div>
      </Alert>
    </>
  );
}
